import type { LiveTruck } from '@chukua/common';
import { truckMapStatus, type TruckMapStatus } from './truck-map-status';

/** What the map is narrowed to. An empty or unset field narrows nothing; the set is applied to every truck in the browser, because a map of one page would be wrong. */
export interface LiveTruckFilters {
  statuses: TruckMapStatus[];
  customerId?: string;
  originZoneCode?: string;
  destinationZoneCode?: string;
}

export const NO_LIVE_TRUCK_FILTERS: LiveTruckFilters = { statuses: [] };

export function isFilteringLiveTrucks(filters: LiveTruckFilters): boolean {
  return filters.statuses.length > 0 || Boolean(filters.customerId || filters.originZoneCode || filters.destinationZoneCode);
}

/** A customer or route filter keeps only trucks on a trip, because a truck with no trip has neither. */
export function matchesLiveTruckFilters(truck: LiveTruck, filters: LiveTruckFilters, now: Date): boolean {
  const { statuses } = filters;
  if (statuses.length > 0 && !statuses.includes(truckMapStatus(truck.fix, now))) return false;
  return matchesTripFilters(truck.trip, filters);
}

function matchesTripFilters(trip: LiveTruck['trip'], { customerId, originZoneCode, destinationZoneCode }: LiveTruckFilters): boolean {
  const wanted: [string | undefined, string | null | undefined][] = [
    [customerId, trip?.customerId],
    [originZoneCode, trip?.originZoneCode],
    [destinationZoneCode, trip?.destinationZoneCode],
  ];
  return wanted.every(([filter, actual]) => !filter || filter === actual);
}

export function filterLiveTrucks(trucks: LiveTruck[], filters: LiveTruckFilters, now: Date): LiveTruck[] {
  return trucks.filter((truck) => matchesLiveTruckFilters(truck, filters, now));
}
